module.exports = function() {
  return new Worker(__webpack_public_path__ + "cdcc71f0b52eed1d9575.worker.js");
};